export default "__VITE_ASSET__BVtnGtks__"